// frontend/src/router/index.js
import {createRouter, createWebHistory} from 'vue-router';
import FileUpload from '../components/FileUpload.vue';
import FileDownload from '../components/FileDownload.vue';
import ViewFile from '../components/ViewFile.vue';

export default new createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'FileUpload',
            component: FileUpload
        },
        {
            path: '/download',
            name: 'FileDownload',
            component: FileDownload
        },
        {
            path: '/view/:fileId',
            name: 'ViewFile',
            component: ViewFile
        }
    ]
});
